import { IAsynchronouslyLoadedValue } from './asynchronouslyLoadedValue';

export type UnitStatus = 'OPEN' | 'RELEASED' | 'SHIPPED' | 'CANCELED';
export type SalesOrderDemandSortAttribute =
    | 'PURCHASE_ORDER_ID'
    | 'CREATION_DATE'
    | 'SHIP_TO_LOCATION_CODE'
    | 'UNITS_OPEN'
    | 'UNITS_CANCELED'
    | 'UNITS_SHIPPED'
    | 'UNITS_ORDERED'
    | 'UNITS_RELEASED'
    | 'REQUESTED_SHIP_DATE'
    | 'REQUESTED_DELIVERY_DATE';
export type SortOrder = 'ASCENDING' | 'DESCENDING';

export enum SalesOrderDemandSortDirection {
    ascending = 'ascending',
    descending = 'descending',
}

export interface SalesOrderDemandShipmentItem {
    asin: string;
    shippedQuantity: number;
}

export interface SalesOrderDemandShipment {
    shipmentId: string;
    units: number;
    status: string;
    carrierSCAC?: string;
    trackingNumber?: string;
    trackingUrl?: string;
    shipDate?: number;
    deliveryDate?: number;
    items: SalesOrderDemandShipmentItem[];
}

export interface SalesOrderDemandItem {
    asin: string;
    orderedQuantity: number;
    openQuantity: number;
    shippedQuantity: number;
    canceledQuantity: number;
    releasedQuantity: number;
}

export interface SalesOrderDemand {
    demandId: string;
    purchaseOrderId: string;
    totalUnitsOrdered: number;
    totalUnitsOpen: number;
    totalUnitsReleased: number;
    totalUnitsShipped: number;
    totalUnitsCanceled: number;
    status?: string;
    creationDate?: number;
    shipToLocationCode?: string;
    requestedShipDate?: number;
    requestedDeliveryDate?: number;
    items: SalesOrderDemandItem[];
    shipments?: SalesOrderDemandShipment[];
}

export interface SalesOrderDemandFilter {
    purchaseOrderIds?: string[];
    unitsStatuses?: UnitStatus[];
    itemIds?: string[];
    resellerSkus?: string[];
    itemFamilies?: string[];
    shipToLocationCodes?: string[];
    creationDateStart?: number;
    creationDateEnd?: number;
    requestedShipDateStart?: number;
    requestedShipDateEnd?: number;
    requestedDeliveryDateStart?: number;
    requestedDeliveryDateEnd?: number;
}

export interface GetSalesOrderDemandsInput {
    resellerId: string;
    maxResults: number;
    startAtResult: number;
    filters?: SalesOrderDemandFilter;
    sortConditions?: Record<SalesOrderDemandSortAttribute, SortOrder>;
}

export interface GetSalesOrderDemandsOutput {
    salesOrderDemands: SalesOrderDemand[];
    totalResults: number;
}

export interface ExportSalesOrderDemandsInput {
    resellerId: string;
    filters?: SalesOrderDemandFilter;
    locale?: string;
    resellerIanaTimezone?: string;
}

export interface ExportSalesOrderDemandsOutput {
    contentType: string;
    content: string;
}

export type DateFilterField = 'creationDate' | 'requestedShipDate' | 'requestedDeliveryDate';

export interface SalesOrderDemandListState {
    currentPage: number;
    sortColumn: string;
    sortDirection: SalesOrderDemandSortDirection;
    dateRange: string[];
    dateFilterField: DateFilterField;
    startAt: number;
    currentRecordNumber: number;
    totalRecords: number;
    poIds: string[];
    unitsStatusFilter: string[];
    asinFilter: string[];
    resellerSkuFilter: string[];
    familyFilter: string[];
    shipToLocationFilter: string[];
    salesOrderDemandData: IAsynchronouslyLoadedValue<SalesOrderDemand[]>;
}
